const ConfigBuilder = require('ConfigBuilder');

const loadConfig = {
    // provider: 'ps', // ex.yggdrasil
    provider: 'yggdrasil',
    token: '6569516516', // comment this line for random token
    languageCode: 'en',
    // eslint-disable-next-line max-len
    fontExceptionsLanguageList: ['vi', 'it', 'lv', 'ro', 'sk', 'tr', 'bg', 'el', 'ja', 'ru', 'sr', 'uk', 'cz', 'kr', 'th', 'vi', 'ka', 'pl', 'zh-hant', 'zh-hans', 'polish'],
    extensionName: 'hammer-of-gods',
    gameName: 'Hammer of gods',
    gameDisplayName: 'Hammer Of Gods',
    // localEngineWrapper: true, // uncomment to test engine wrapper: port 4000
    // localGameExtension: false, // ucomment to test game extension: port 4001
    launchParams: {
        areEventsReplayEnabled: true,
        cheat: true,
        maxExposure: 51000,
        engineVersion: { major: 2, minor: 9, patch: 1 }
    }, // custom laucnh params
    psConfig: {
        engineWrapperVersion: '1.2.11',
        extensionVersion: '1.0.11',
        servers: ['wss://services.peterandsons.org/ws'],
        gameCode: 'hammer-of-gods'
    },
    yggdrasilConfig: {
        engineWrapperVersion: '1.5.6',
        extensionVersion: '1.0.11',
        customGameExtension: 'https://clients.peterandsons.org/hammer-of-gods-ps-extensions/1.0.11/engine-extensions.js',
        servers: ['wss://services.peterandsons.org/ws'],
        gameCode: 'hammer-of-gods',
        areEventsReplayEnabled: true,
    },
    cheatConfig: {
        reelsAmount: 6,
        reelsets: ['B1', 'B2', 'F1', 'F2'],
        cheats: [
            { id: '3-scatter', reelset: 'B1', result: [[ 8, 1, 26, 23, 10, 0 ]] },
            { id: 'H1', reelset: 'B1', result: [[ 3, 21, 1, 10, 8, 7 ]] },
            { id: 'H2', reelset: 'B1', result: [[ 5, 3, 3, 0, 0, 0 ]] },
            { id: 'H3', reelset: 'B1', result: [[ 14, 12, 9, 7, 11, 10 ]] },
            { id: 'H4', reelset: 'B1', result: [[ 1, 65, 11, 13, 14, 13 ]] },
            { id: 'H5', reelset: 'B1', result: [[ 12, 13, 23, 21, 17, 16 ]] },
        ],
        debugEvents: [
            { id: 'TotalPrize' },
            { id: 'TotalPrizeSmall' },
            { id: 'bigwin' },
            { id: 'megawin' },
            { id: 'epicwin' },
        ]
    }
};
const config = ConfigBuilder.build(loadConfig);

export default config;
